<template>
  <div class="cube-theme-editor">
    <el-popover width="250" trigger="click">
      <div class="editor-tit">
        主题色
        <el-tooltip effect="dark" content="组件配色" placement="top-start">
          <el-button
            type="text"
            icon="el-icon-edit"
            size="mini"
            @click="ifEditor('color', true)"
          ></el-button>
        </el-tooltip>
      </div>
      <el-row justify="space-between">
        <el-col>
          <el-tooltip
            v-for="(item, index) in themeList"
            :key="index"
            effect="dark"
            :content="item.name"
            placement="top-start"
          >
            <div
              class="color-bar"
              :class="{ cur: themeClass == item.value }"
              @click="changeTheme(item.value)"
            >
              <div
                class="color-bar-inner"
                :style="'background:' + item.color"
              ></div>
            </div>
          </el-tooltip>
          <el-tooltip effect="dark" content="自定义颜色" placement="top-start">
            <el-color-picker
              v-model="themeColor"
              class="color-bar"
              :class="{ cur: themeClass == '自定义颜色' }"
              size="mini"
              @change="addThemeStyle"
              @active-change="addThemeStyle"
            ></el-color-picker>
          </el-tooltip>
        </el-col>
      </el-row>
      <div class="editor-tit">
        布局
        <el-tooltip effect="dark" content="更多" placement="top-start">
          <el-button
            type="text"
            icon="el-icon-edit"
            size="mini"
            @click="ifEditor('space', true)"
          ></el-button>
        </el-tooltip>
      </div>
      <el-row>
        <el-col>
          <el-radio-group
            :value="spaceClass"
            @input="addClass($event, 'spaceClass')"
          >
            <el-radio label="spacing-default">默认</el-radio>
            <el-radio label="spacing-efficient">高效</el-radio>
            <el-radio label="spacing-compact">紧凑</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <div class="editor-tit">缩放：</div>
      <el-row>
        <el-col>
          <el-switch
            v-model="scale"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-col>
      </el-row>
      <cnd-icon slot="reference" name="cnd-eyes" />
    </el-popover>
    <EditorColor
      :show-editor="showEditorColor"
      @ifEditor="ifEditor"
      @getComponentStyle="getComponentStyle"
    />
    <EditorSpace
      :show-editor="showEditorSpace"
      @ifEditor="ifEditor"
      @getComponentStyle="getComponentStyle"
    />
  </div>
</template>

<script>
import '../../../../lib/styles/components/ThemeEditor.scss'
import { zoom, getColorScaleCssVariable } from './util'
import EditorColor from './editorColor.vue'
import EditorSpace from './editorSpace.vue'

export default {
  name: 'ThemeEditor',
  components: {
    EditorColor,
    EditorSpace
  },
  props: {
    themeConfig: {
      type: Array,
      default: () => []
    },
    theme: {
      type: String,
      default: 'theme-default'
    }
  },
  data() {
    return {
      // 编辑配置
      showEditorColor: false,
      showEditorSpace: false,
      // 缩放配置
      scale: false,
      spaceClass: 'spacing-default',
      scaleClassName: ['var100', 'var110', 'var125', 'var137', 'var150'],
      spaceClassName: [
        'spacing-default',
        'spacing-efficient',
        'spacing-compact'
      ],
      // 主题配置
      themeClass: this.theme,
      themeColor: '',
      themeClassName: [
        {
          name: '默认',
          value: 'theme-default',
          color: 'gray'
        },
        {
          name: '活力蓝',
          value: 'theme-blue',
          color: '#0047c3'
        },
        {
          name: '深邃黑',
          value: 'theme-black',
          color: '#23262E'
        }
      ],
      // style
      themeStyle: '',
      colorStyle: '',
      spaceStyle: ''
    }
  },
  computed: {
    themeList() {
      return this.themeClassName.concat(this.themeConfig)
    }
  },
  watch: {
    scale(newVal, oldVal) {
      if (newVal) {
        window.addEventListener('resize', this.doScale)
      }
    },
    themeStyle(newVal, oldVal) {
      document.body.style = newVal + this.colorStyle + this.spaceStyle
    }
  },
  mounted() {
    // 判断组件
    var localColor = JSON.parse(localStorage.getItem('colorStyle'))
    if (localColor !== null) {
      this.colorStyle = localColor.saveStyles
      this.getComponentStyle({
        type: 'color',
        saveStyles: this.colorStyle
      })
    }
    var localSpace = JSON.parse(localStorage.getItem('spaceStyle'))
    if (localSpace !== null) {
      this.spaceStyle = localSpace.saveStyles
      this.getComponentStyle({
        type: 'space',
        saveStyles: this.spaceStyle
      })
    }
    // 判断主题
    var localTheme = localStorage.getItem('themeClass')
    if (localTheme !== null) {
      this.themeClass = localTheme
      if (localTheme === '自定义颜色') {
        this.themeColor = localStorage.getItem('themeColor')
        this.addThemeStyle(this.themeColor)
      } else {
        this.addClass(this.themeClass, 'themeClass')
      }
    } else {
      this.addClass(this.themeClass, 'themeClass')
    }
    // 判断布局
    if (localStorage.getItem('spaceClass')) {
      this.addClass(localStorage.getItem('spaceClass'), 'spaceClass')
    } else {
      this.addClass('spacing-default', 'spaceClass')
    }
  },
  methods: {
    // 缩放逻辑
    doScale() {
      const BASE_SCREEN_WIDTH = 1920
      const { dpi, browserScale, windowsScale, screenWidth } = zoom()
      console.log('-------------zoom--------------')
      console.log('dpi', dpi)
      console.log('browserScale', browserScale)
      console.log('windowsScale', windowsScale)
      console.log('screenWidth', screenWidth)
      // 针对屏幕尺寸为 1920 及以下的系统缩放和浏览器进行处理

      // 屏幕大于 1920，视为高分辨率屏幕，理应有足够空间显示内容，因此不对用户的缩放行为进行处理
      if (
        screenWidth <= BASE_SCREEN_WIDTH &&
        windowsScale > 0.99 &&
        browserScale > 0.99
      ) {
        // 系统缩放实际缩放不能直接取 dpi, 而是根据取当前屏幕宽度与基准宽度的比例
        const systemScale = BASE_SCREEN_WIDTH / screenWidth
        // 系统缩放 * 浏览器缩放 = 整体缩放比例
        const realScale = systemScale * browserScale

        console.log(
          `当前屏幕宽度小于 1920，实际缩放比例: ${realScale} = ${systemScale} * ${browserScale}`
        )
        if (realScale >= 1 && realScale < 1.1) {
          setFontSize(100)
          this.addClass('var100', 'scaleClass')
        }
        if (realScale >= 1.1 && realScale < 1.25) {
          setFontSize(90)
          this.addClass('var110', 'scaleClass')
        }
        if (realScale >= 1.25 && realScale < 1.37) {
          setFontSize(80)
          this.addClass('var125', 'scaleClass')
        }
        if (realScale >= 1.37 && realScale < 1.5) {
          setFontSize(72)
          this.addClass('var137', 'scaleClass')
        }
        if (realScale >= 1.5 && realScale < 1.75) {
          setFontSize(72)
          this.addClass('var150', 'scaleClass')
        }
        if (realScale >= 1.75) {
          setFontSize(66)
        }
      }
      function setFontSize(size) {
        document.documentElement.style.fontSize = size + 'px'
      }
    },
    // 新增class类名
    addClass(newClass, type) {
      // body的class新增：缩放、主题、紧凑
      const bodyClass = document.body.classList
      bodyClass.remove(this[type])
      this.$nextTick(() => {
        bodyClass.add(newClass)
        this[type] = newClass
      })
      // ag-表格：颜色、缩放、紧凑相关
      const el = document.querySelectorAll('.ag-theme-balham')
      for (let i = 0; i < el.length; i++) {
        el[i].classList.remove(this[type])
        this.$nextTick(() => {
          el[i].classList.add(newClass)
          this[type] = newClass
        })
      }
      // 保存状态
      if (type === 'spaceClass') {
        localStorage.setItem('spaceClass', newClass)
      }
      if (type === 'themeClass') {
        localStorage.setItem('themeClass', newClass)
        this.checkSidebar()
      }
    },
    // sidebar颜色不为灰色的时候marginRight为12px
    checkSidebar() {
      this.$nextTick(() => {
        const elem = document.querySelector('.sidebar-wrapper')
        if (elem) {
          const styles = getComputedStyle(elem)
          var curSidebarBg = styles.getPropertyValue('background-color')
          if (curSidebarBg !== 'rgb(237, 239, 242)') {
            const siderRedElements =
              document.querySelectorAll('.sidebar-container')
            siderRedElements.forEach((element) => {
              element.style.marginRight = '12px'
            })
          } else {
            const siderRedElements =
              document.querySelectorAll('.sidebar-container')
            siderRedElements.forEach((element) => {
              element.style.marginRight = '0px'
            })
          }
        }
      })
    },
    // style插入主题色
    addThemeStyle(color) {
      document.body.classList.remove(this.themeClass)
      this.themeClass = '自定义颜色'
      this.themeStyle = getColorScaleCssVariable(color, 'primary')
      localStorage.setItem('themeColor', color)
      localStorage.setItem('themeClass', '自定义颜色')
    },
    changeTheme(newTheme) {
      if (newTheme === '自定义颜色') {
        document.body.classList.remove(this.themeClass)
        this.themeClass = '自定义颜色'
        this.addThemeStyle(this.themeColor)
      } else {
        this.themeStyle = ''
        this.addClass(newTheme, 'themeClass')
      }
    },
    // 编辑处理
    ifEditor(type, ifEditor) {
      switch (type) {
        case 'color':
          this.showEditorColor = ifEditor
          break
        case 'space':
          this.showEditorSpace = ifEditor
          break

        default:
          break
      }
    },
    getComponentStyle(obj) {
      switch (obj.type) {
        case 'color':
          this.colorStyle = obj.saveStyles
          break
        case 'space':
          this.spaceStyle = obj.saveStyles
          break

        default:
          break
      }
      document.body.style = this.themeStyle + this.colorStyle + this.spaceStyle
    }
  }
}
</script>
